/* eslint-disable */
import {execute, grable} from '../concrete'

const concreteModuleName = 'concrete'

const NewManagementService = {
    /**
     * 删除信息直报
     * @param {*} id 
     * @returns Promise 
     */
    'delNews': function (id) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'ecf64c7a0dc2f5ead935505fe1c0fc123da666c2', id)
            : execute(concreteModuleName, `/NewManagement/delNews`, 'json', 'POST', { id });
    }, 
    /**
     * 上传文件
     * @param {*} filePo 
     * @returns Promise 
     */
    'uploadFile': function (filePo) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '338a9be1ee43c72fbf697d0cac790c73ce62d46c', filePo)
            : execute(concreteModuleName, `/NewManagement/uploadFile`, 'text', 'POST', filePo);
    }, 
    /**
     * 保存或者修改信息直报
     * @param {*} newsPo 
     * @returns Promise 
     */
    'saveOrUpdateNews': function (newsPo) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '701ce62b88950ad45beea0eb675d4e6b6659fcf5', newsPo)
            : execute(concreteModuleName, `/NewManagement/saveOrUpdateNews`, 'json', 'POST', newsPo);
    }, 
    /**
     * 信息直报详情
     * @param {*} aid 
     * @returns Promise 
     */
    'NewsInfo': function (aid) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, 'c030eb4972fd88f40a603aad05f579d1922517d7', aid)
            : execute(concreteModuleName, `/NewManagement/NewsInfo`, 'json', 'POST', { aid });
    }, 
    /**
     * 信息直报列表
     * @param {*} num 
     * @param {*} pageSize 
     * @returns Promise 
     */
    'NewsInformationListForPage': function (num, pageSize) {
        return  grable(concreteModuleName)
            ? execute(concreteModuleName, '521cb8bea65a7dcab4108fae5a7d5b2f241b21ac', {num, pageSize})
            : execute(concreteModuleName, `/NewManagement/NewsInformationList`, 'json', 'POST', { num, pageSize });
    }
}

export default NewManagementService
